import type { AuthConfig, AuthToken, AuthStrategy } from '../types';

export interface IAuthPromise<T extends AuthConfig> {
    promise: Promise<AuthToken<T>>;
    config: T;
}

let cache: IAuthPromise<any>[] = [];

function findPromiseByConfig<T extends AuthConfig>(strategy: AuthStrategy, config: T): IAuthPromise<T> {
    return cache.find(
        (cachedPromise) =>
            // App ID matches
            cachedPromise.config.appMetaData &&
            config.appMetaData &&
            cachedPromise.config.appMetaData.id === config.appMetaData.id &&
            // Environment matches
            config.environment === cachedPromise.config.environment &&
            // Context matches
            config.context === cachedPromise.config.context &&
            // Strategy supports the cached config
            strategy.supports(cachedPromise.config)
    );
}

export const addPromise = <T extends AuthConfig>(authPromise: IAuthPromise<T>) => {
    cache.push(authPromise);
};

export const removePromise = <T extends AuthConfig>(strategy: AuthStrategy, config: T) => {
    cache = cache.filter((cachePromise) => cachePromise !== findPromiseByConfig(strategy, config));
};

export const getPromise = <T extends AuthConfig>(strategy: AuthStrategy, config: T): Promise<AuthToken<T>> => {
    const cachedPromise = findPromiseByConfig(strategy, config);
    return cachedPromise && cachedPromise.promise;
};

export const clearPromises = () => {
    cache = [];
};
